'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$002413 from "./presto.-Audit-View$$anon$13.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dCode$0024 from "./presto.types$-User-Code$.js";
import * as $j_presto$002etypes$0024$002dUser$002dEntry$0024 from "./presto.types$-User-Entry$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
import * as $j_presto$002etypes$0024$002dUser$002dKind$0024 from "./presto.types$-User-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$12() {
  this.aAO = null;
  this.aAG = null;
  this.aAH = false;
  this.aAP = null;
  this.aAQ = false;
  this.aAT = null;
  this.aAM = null;
  this.aAN = false;
  this.aAI = null;
  this.aAJ = false;
  this.aAK = null;
  this.aAL = false;
  this.aAR = false;
  this.aAS = false;
  this.aAO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAT = "UserEntry";
}
export { $c_Lpresto_AuditView$$anon$12 as $c_Lpresto_AuditView$$anon$12 };
$p = $c_Lpresto_AuditView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$12;
/** @constructor */
function $h_Lpresto_AuditView$$anon$12() {
}
export { $h_Lpresto_AuditView$$anon$12 as $h_Lpresto_AuditView$$anon$12 };
$h_Lpresto_AuditView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aAO;
});
$p.M = (function() {
  if ((!this.aAH)) {
    this.aAG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAH = true;
  }
  return this.aAG;
});
$p.O = (function() {
  if ((!this.aAQ)) {
    this.aAP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAQ = true;
  }
  return this.aAP;
});
$p.E = (function() {
  return this.aAT;
});
$p.t = (function() {
  if ((!this.aAN)) {
    this.aAM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("active", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.aAN = true;
  }
  return this.aAM;
});
$p.N = (function() {
  if ((!this.aAJ)) {
    this.aAI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dUser$002dKind$0024.$m_Lpresto_types$UserKind$().sB())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dCode$0024.$m_Lpresto_types$UserCode$().sA(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.aAJ = true;
  }
  return this.aAI;
});
$p.Q = (function() {
  if ((!this.aAL)) {
    this.aAK = new $j_presto$002e$002dAudit$002dView$0024$0024anon$002413.$c_Lpresto_AuditView$$anon$13();
    this.aAL = true;
  }
  return this.aAK;
});
$p.v = (function() {
  if ((!this.aAS)) {
    this.aAR = false;
    this.aAS = true;
  }
  return this.aAR;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee103) => ((p) => \u03b4scrutinee103.sv(p)))($j_presto$002etypes$0024$002dUser$002dEntry$0024.$m_Lpresto_types$UserEntry$())));
});
var $d_Lpresto_AuditView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$12, "presto.AuditView$$anon$12", ({
  Eu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AuditView$$anon$12 as $d_Lpresto_AuditView$$anon$12 };
//# sourceMappingURL=presto.-Audit-View$$anon$12.js.map
